import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom'
import { Fire, Time, Tools } from '../../../services'

import { Input, Button } from 'reactstrap'
import { Headerbar, Loader, ConfirmButton, TabsContainer, ListContainer, OrderingBox } from '../../Reusable'

import FadeIn from 'react-fade-in';
import GamesList from './GamesList'

const { useHistory } = require('react-router-dom')

const tabs = [
  {
    title: 'Jeux concours',
    key: 'listing',
  },
]

interface Props {
  match: any;
}
const GamesScreen: React.FC<Props> = (props) => {

  const history = useHistory()
  const [error, setError] = React.useState('')
  const user = useSelector(state => state.authReducer.user)
  const tab = props.match.params.tab || 'listing'

  const renderContent = () => {
    return (
      <React.Fragment>
        <GamesList
          title={"Nos jeux concours"}
          onSelect={(item: any) => history.push('/admin/game/' + item.id)}
          onCreate={() => history.push('/admin/game/new')}
          />
      </React.Fragment>
    )
  }

  return (
    <div className="wrapper">
      <Headerbar
        title={"Jeux concours"}
        />
      <div className="content-wrapper">
        <div className="content">
          <div className="container-fluid">

            <TabsContainer
              tab={tab}
              tabs={tabs}
              onSelect={(tab) => history.push('/games/' + tab.key)}
              />

              <FadeIn key={'fade-' + tab}>
                {renderContent()}
              </FadeIn>
            
          </div>
        </div>
      </div>
    </div>
  );
}
export default withRouter(GamesScreen)